<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/home">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
          <a-card :loading="loading.page" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">
                {{ "Rencana Belanja Manifest".toUpperCase() }}
              </h4>
              <small># {{ data.header.no_rencana_belanja }}</small>
            </div>
            <a-popover  v-if="(user_pembuat || data.header.pembuat)==getAuth.username && !(this.isKuasaAnggaran || this.isDirektur)" slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button-group class="width-full">
                    <a-button
                      type="danger"
                      icon="edit"
                      class="width-full"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button v-if="lastStatus=='Approved'" icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                  <a-card class="margin-top">
                    <ul class="m-list-wrapper bordered">
                      <li>
                        <span class="m-list-title" for>Created Date</span>
                        <span class="m-list-desc">{{
                          moment(data.header.tgl_buat, "DD-MM-YYYY").format(
                            getDefaultDateFormat
                          )
                        }}</span>
                      </li>
                      <li>
                        <span class="m-list-title" for>User Creator</span>
                        <span class="m-list-desc">{{
                          data.header.pembuat
                        }}</span>
                      </li>
                      <li>
                        <span class="m-list-title" for>Periode</span>
                        <span class="m-list-desc"
                          >{{ data.header.periode_bulan }} -
                          {{ data.header.periode_tahun }}</span
                        >
                      </li>
                      <li>
                        <a-table
                          :rowKey="(record, index) => { return index; }"
                          :columns="columns"
                          :dataSource="data.detil"
                          id="table_dtl"
                          size="small"
                          :pagination="false"
                          :loading="loading.page"
                          :scroll="{ x: 1000, y: '100vh' }"
                          bordered
                          class="margin-top"
                        >
                          <template slot="no" slot-scope="text, item, index">
                            {{ index + 1 }}
                          </template>
                          <template slot="cost_center" slot-scope="item">
                            {{ item.cost_center_kode }}
                          </template>
                          <template slot="code_budget" slot-scope="item">
                            <div>{{ item.kode_anggaran }}</div>
                            <div>{{ item.item_anggaran }}</div>
                          </template>
                          <template slot="description" slot-scope="item">
                            {{ item.deskripsi }}
                          </template>
                          <template slot="nilai" slot-scope="item">
                            <CurrencyJustified
                              :currencyValue="'IDR'"
                              :valueNumber="item.nilai_rencana"
                            />
                          </template>
                          <template slot="pp" slot-scope="item">
                            <a-button
                              :disabled="
                                (item.is_plafon == '0' &&
                                  item.is_cancel == '0') ||
                                  (item.is_plafon == '0' &&
                                    item.is_cancel == '1')
                              "
                              size="small"
                              icon="plus"
                              type="primary"
                              @click="toCreatePP(item)"
                            />
                          </template>
                          <template slot="plafon" slot-scope="item">
                            <a-tag
                              v-if="
                                item.is_plafon == '1' && item.is_cancel == '0'
                              "
                              color="green"
                              class="m-width-full"
                              >On Plafon</a-tag
                            >
                            <a-tag
                              v-else-if="
                                item.is_plafon == '0' && item.is_cancel == '1'
                              "
                              color="red"
                              class="m-width-full"
                              >Canceled</a-tag
                            >
                            <a-tag v-else color="grey" class="m-width-full"
                              >Not yet</a-tag
                            >
                          </template>

                          <template slot="pp_status" slot-scope="item">
                            <a-tag v-if="item.pp_create == '1'" color="green" class="m-width-full">Created</a-tag>
                            <a-tag v-else color="grey" class="m-width-full">Not Created</a-tag>
                          </template>

                          <template slot="sts" slot-scope="item">
                            <a-tag
                              :color="
                                item.status == 'High'
                                  ? 'red'
                                  : item.status == 'Normal'
                                  ? 'green'
                                  : item.status == 'Direct'
                                  ? 'purple'
                                  : 'pink'
                              "
                              :class="
                                item.status == 'Low'
                                  ? 'width-full tag-defaults'
                                  : 'width-full'
                              "
                              >{{
                                item.status
                                  ? item.status == "Direct"
                                    ? "Direct Allocated"
                                    : item.status
                                  : ""
                              }}</a-tag
                            >
                          </template>
                          <!-- <template slot="aksi" slot-scope="item">
                            <a-button size="small" icon="close" type="danger" 
                              :loading="loading.delete_key==item.rencana_belanja_dtl_id"
                              @click="handleDelete(item)">
                            </a-button>
                          </template> -->
                          <template slot="footer">
                            <b>Total Rencana Belanja : </b>
                            {{ formatRupiah(totalValue).replace(",00", "") }}
                          </template>
                        </a-table>
                      </li>
                    </ul>
                  </a-card>
                  <a-card
                    v-if="data.jenis === 'Approve' && data.aksi.length > 0"
                    class="margin-top"
                  >
                    <div slot="title">Manifest Actions</div>

                    <a-form :form="form">
                      <a-form-item label="Note">
                        <a-textarea
                          placeholder="Write the note here ... "
                          :rows="4"
                          v-decorator="['catatan']"
                        />
                      </a-form-item>
                      <a-form-item label="Aksi">
                        <a-select
                          v-decorator="[
                            'aksi',
                            {
                              rules: [{ required: true }],
                              initialValue: data.aksi[0].aksi,
                            },
                          ]"
                        >
                          <a-select-option
                            v-for="item in data.aksi"
                            :key="item.aksi"
                            >{{ item.aksi }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                      <a-form-item :wrapper-col="{ span: 24 }">
                        <a-button
                          @click="handleAction"
                          block
                          type="primary"
                          html-type="submit"
                          :loading="loading.submit"
                          >Save</a-button
                        >
                      </a-form-item>
                    </a-form>
                  </a-card>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-collapse class="margin-top" activeKey="1">
                    <a-collapse-panel key="1">
                      <div
                        class="m-display-flex space-between align-middle"
                        slot="header"
                      >
                        <h4 class="margin-remove">Status</h4>
                        <div>
                          <Status :status="lastStatus" />
                          <!-- <a-button
                            @click="historyToggle"
                            type="default"
                            size="small"
                            class="margin-right-small"
                          >
                            History
                            <a-icon type="history" />
                          </a-button> -->
                        </div>
                      </div>
                      <a-timeline class="m-timeline">
                        <a-timeline-item color="green">
                          <div class="m-timeline-title">
                            Creator - {{ data.header.pembuat }}
                          </div>
                          <div class="m-timeline-body">
                            <h4 class="margin-remove">
                              {{
                                moment(
                                  data.header.tgl_buat,
                                  "DD-MM-YYYY"
                                ).format(getDefaultDateFormat)
                              }}
                            </h4>
                            <span
                              class="m-text-small"
                              v-if="data.header.catatan"
                            >
                              {{ data.header.catatan }}
                            </span>
                            <span class="m-text-small" v-else
                              >Tidak Ada Catatan</span
                            >
                          </div>
                          <div class="m-timeline-footer">
                            <a-tag color="green">Created</a-tag>
                          </div>
                        </a-timeline-item>
                        <a-timeline-item
                          v-for="workflow in data.workflow"
                          :key="workflow.step_no"
                          :color="
                            workflow.status === 'On Process' ||
                            workflow.status === 'Delivered'
                              ? 'red'
                              : workflow.status === 'Waiting'
                              ? 'grey'
                              : 'green'
                          "
                        >
                          <div class="m-timeline-title">
                            {{
                              workflow.actor === null
                                ? workflow.jenis
                                : workflow.actor
                            }}
                            {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                          </div>
                          <div class="m-timeline-body">
                            <h4
                              class="margin-remove"
                              v-if="workflow.tanggal_aksi !== null"
                            >
                              {{
                                moment(workflow.tanggal_aksi).format(
                                  getDefaultDateFormat
                                )
                              }}
                            </h4>
                            <span class="m-text-small" v-if="workflow.remark">
                              {{ workflow.remark }}
                            </span>
                            <span class="m-text-small" v-else
                              >Tidak Ada Catatan</span
                            >
                          </div>
                          <div class="m-timeline-footer">
                            <Status :status="workflow.status" />
                          </div>
                        </a-timeline-item>
                      </a-timeline>
                    </a-collapse-panel>
                  </a-collapse>
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ManifestPlanExpenditure",
  props: ["id", "user_pembuat"],
  mixins: [GlobalMethod, CurrencyFormat, HandleRoute],
  data() {
    return {
      loading: {
        page: true,
        delete_key: "",
        submit: false,
      },
      visibleHistory: false,
      data: {
        header: [],
        detil: [],
        workflow: [],
        aksi: [],
        jenis: "manifest",
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {},
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
    ]),
    columns() {
      let kolom = [
        {
          title: "#",
          width: "50px",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "PP",
          width: "50px",
          align: "center",
          scopedSlots: { customRender: "pp" },
        },
        {
          title: "Plafon",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "plafon" },
        },
        {
          title: "PP status",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "pp_status" },
        },
        {
          title: "Status",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "sts" },
        },
        {
          title: "Cost Center",
          width: "150px",
          scopedSlots: { customRender: "cost_center" },
        },
        {
          title: "Code | Item Budget",
          width: "350px",
          scopedSlots: { customRender: "code_budget" },
        },
        {
          title: "Description",
          width: "350px",
          scopedSlots: { customRender: "description" },
        },
        {
          title: "Value",
          width: "150px",
          scopedSlots: { customRender: "nilai" },
        },
        {
          title: "Director Note",
          width: "150px",
          dataIndex: "director_note",
        },
        //{
        //  title: "#",
        //  width: '50px',
        //  fixed: "right",
        //  scopedSlots: { customRender: "aksi" },
        //},
      ];

      if(this.isKuasaAnggaran || this.isDirektur){
        kolom.splice(1, 1); 
      }
      return kolom;
    },
    totalValue() {
      return _.sumBy(this.data.detil, function(val) {
        return Number(val.nilai_rencana);
      });
    },
    lastStatus() {
      let sts =
        this.data.workflow.length > 0
          ? this.data.workflow[this.data.workflow.length - 1].status
          : "Closed";
      return sts == "Delivered" ? "On Process" : sts;
    },
    isKuasaAnggaran(){
      return this.$route.meta.isKuasaAnggaran
    },
    isDirektur(){
      return this.$route.meta.isDirektur
    }
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading.page = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "rencana_belanja",
        params: {
          rencana_belanja_id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header: response.data.hdr[0],
            detil: response.data.dtl,
            workflow: response.data.worlflow,
            aksi: response.data.aksi,
            jenis: response.data.jenis,
          };
          this.loading.page = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    handleDelete(item) {
      const that = this;

      this.$confirm({
        title: "Are you sure to delete?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete_key = item.rencana_belanja_dtl_id;

          that
            .asyncAxiosDelete(
              "Rencana_belanja/hapus",
              "application/json",
              that.getAuth,
              { rencana_belanja_dtl_id: item.rencana_belanja_dtl_id }
            )
            .then((response) => {
              that.loading.delete_key = "";

              that.data.dtl = response.dtl;

              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
            })
            .catch(() => {
              that.loading.delete_key = "";
            });
        },
        onCancel() {},
      });
    },
    handleEdit() {
      this.$router.push({
        name: "expenditurePlanRevise",
        params: { id: this.id },
      });
    },
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let addData = new FormData();
        addData.append("rencana_belanja_id", this.id);
        addData.append("status", values.aksi);
        addData.append("remark", values.catatan ? values.catatan : "");

        this.loading.submit = true;
        this.asyncAxiosPost(
          "Rencana_belanja/approval",
          "formdata",
          this.getAuth,
          addData
        )
          .then(() => {
            this.displayMessage("success");
            this.fetchManifest();
            this.loading.submit = false;
          })
          .catch((err) => {
            this.loading.submit = false;
            console.log("error : " + err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      });
    },
    toCreatePP(item) {
      const route = this.$router.resolve({
        name: "createPP",
        query: {
          ref_dtl: item.rencana_belanja_dtl_id,
        },
      });
      window.open(route.href, "_blank");
    },
  },
  mounted() {
    this.form = this.$form.createForm(this);
    this.fetchManifest();
  },
  beforeDestroy() {},
};
</script>

<style></style>
